//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAddKlantcontactRouteringOverrideEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    overridesPOST(formuliersleutel: string, body?: AddKlantcontactRouteringOverrideCommand | undefined): Promise<void>;
}

export class AddKlantcontactRouteringOverrideEndpointClient implements IAddKlantcontactRouteringOverrideEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    overridesPOST(formuliersleutel: string, body?: AddKlantcontactRouteringOverrideCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen/{formuliersleutel}/overrides";
        if (formuliersleutel === undefined || formuliersleutel === null)
            throw new Error("The parameter 'formuliersleutel' must be defined.");
        url_ = url_.replace("{formuliersleutel}", encodeURIComponent("" + formuliersleutel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverridesPOST(_response);
        });
    }

    protected processOverridesPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUpdateKlantcontactRouteringOverrideEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    overridesPUT(formuliersleutel: string, body?: UpdateKlantcontactRouteringOverrideCommand | undefined): Promise<void>;
}

export class UpdateKlantcontactRouteringOverrideEndpointClient implements IUpdateKlantcontactRouteringOverrideEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    overridesPUT(formuliersleutel: string, body?: UpdateKlantcontactRouteringOverrideCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen/{formuliersleutel}/overrides";
        if (formuliersleutel === undefined || formuliersleutel === null)
            throw new Error("The parameter 'formuliersleutel' must be defined.");
        url_ = url_.replace("{formuliersleutel}", encodeURIComponent("" + formuliersleutel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverridesPUT(_response);
        });
    }

    protected processOverridesPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICreateKlantcontactEndpointClient {
    /**
     * @param persoonId (optional) 
     * @param body (optional) 
     * @return Success
     */
    klantcontacten(persoonId?: number | undefined, body?: CreateKlantcontactCommand | undefined): Promise<KlantcontactBevestiging>;
}

export class CreateKlantcontactEndpointClient implements ICreateKlantcontactEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param persoonId (optional) 
     * @param body (optional) 
     * @return Success
     */
    klantcontacten(persoonId?: number | undefined, body?: CreateKlantcontactCommand | undefined, cancelToken?: CancelToken): Promise<KlantcontactBevestiging> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten?";
        if (persoonId === null)
            throw new Error("The parameter 'persoonId' cannot be null.");
        else if (persoonId !== undefined)
            url_ += "persoonId=" + encodeURIComponent("" + persoonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKlantcontacten(_response);
        });
    }

    protected processKlantcontacten(response: AxiosResponse): Promise<KlantcontactBevestiging> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KlantcontactBevestiging.fromJS(resultData200);
            return Promise.resolve<KlantcontactBevestiging>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KlantcontactBevestiging>(null as any);
    }
}

export interface ICreateKlantcontactRouteringEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    routeringenPOST(body?: CreateKlantcontactRouteringCommand | undefined): Promise<void>;
}

export class CreateKlantcontactRouteringEndpointClient implements ICreateKlantcontactRouteringEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    routeringenPOST(body?: CreateKlantcontactRouteringCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRouteringenPOST(_response);
        });
    }

    protected processRouteringenPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IGetAllKlantcontactRouteringenEndpointClient {
    /**
     * @return Success
     */
    routeringenAll(): Promise<KlantcontactRouteringReadModel[]>;
}

export class GetAllKlantcontactRouteringenEndpointClient implements IGetAllKlantcontactRouteringenEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    routeringenAll( cancelToken?: CancelToken): Promise<KlantcontactRouteringReadModel[]> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRouteringenAll(_response);
        });
    }

    protected processRouteringenAll(response: AxiosResponse): Promise<KlantcontactRouteringReadModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KlantcontactRouteringReadModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KlantcontactRouteringReadModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KlantcontactRouteringReadModel[]>(null as any);
    }
}

export interface IDeleteKlantcontactRouteringOverrideEndpointClient {
    /**
     * @return Success
     */
    overridesDELETE(formuliersleutel: string, regeling: Regeling): Promise<void>;
}

export class DeleteKlantcontactRouteringOverrideEndpointClient implements IDeleteKlantcontactRouteringOverrideEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    overridesDELETE(formuliersleutel: string, regeling: Regeling, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen/{formuliersleutel}/overrides/{regeling}";
        if (formuliersleutel === undefined || formuliersleutel === null)
            throw new Error("The parameter 'formuliersleutel' must be defined.");
        url_ = url_.replace("{formuliersleutel}", encodeURIComponent("" + formuliersleutel));
        if (regeling === undefined || regeling === null)
            throw new Error("The parameter 'regeling' must be defined.");
        url_ = url_.replace("{regeling}", encodeURIComponent("" + regeling));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverridesDELETE(_response);
        });
    }

    protected processOverridesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUpdateKlantcontactRouteringEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    routeringenPUT(formuliersleutel: string, body?: UpdateKlantcontactRouteringCommand | undefined): Promise<void>;
}

export class UpdateKlantcontactRouteringEndpointClient implements IUpdateKlantcontactRouteringEndpointClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    routeringenPUT(formuliersleutel: string, body?: UpdateKlantcontactRouteringCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontacten/routeringen/{formuliersleutel}";
        if (formuliersleutel === undefined || formuliersleutel === null)
            throw new Error("The parameter 'formuliersleutel' must be defined.");
        url_ = url_.replace("{formuliersleutel}", encodeURIComponent("" + formuliersleutel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRouteringenPUT(_response);
        });
    }

    protected processRouteringenPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AddKlantcontactRouteringOverrideCommand implements IAddKlantcontactRouteringOverrideCommand {
    formuliersleutel!: string;
    regeling!: Regeling;
    route!: KlantcontactRoute;

    constructor(data?: IAddKlantcontactRouteringOverrideCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.route = data.route && !(<any>data.route).toJSON ? new KlantcontactRoute(data.route) : <KlantcontactRoute>this.route;
        }
        if (!data) {
            this.route = new KlantcontactRoute();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formuliersleutel = _data["formuliersleutel"];
            this.regeling = _data["regeling"];
            this.route = _data["route"] ? KlantcontactRoute.fromJS(_data["route"]) : new KlantcontactRoute();
        }
    }

    static fromJS(data: any): AddKlantcontactRouteringOverrideCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddKlantcontactRouteringOverrideCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formuliersleutel"] = this.formuliersleutel;
        data["regeling"] = this.regeling;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddKlantcontactRouteringOverrideCommand {
    formuliersleutel: string;
    regeling: Regeling;
    route: IKlantcontactRoute;
}

export class Bestand implements IBestand {
    bestandsnaam!: string;
    base64Inhoud!: string;

    constructor(data?: IBestand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bestandsnaam = _data["bestandsnaam"];
            this.base64Inhoud = _data["base64Inhoud"];
        }
    }

    static fromJS(data: any): Bestand {
        data = typeof data === 'object' ? data : {};
        let result = new Bestand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestandsnaam"] = this.bestandsnaam;
        data["base64Inhoud"] = this.base64Inhoud;
        return data;
    }
}

export interface IBestand {
    bestandsnaam: string;
    base64Inhoud: string;
}

export class Contactgegevens implements IContactgegevens {
    email!: string;
    telefoonnummer?: string | undefined;
    mobielnummer?: string | undefined;

    constructor(data?: IContactgegevens) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.telefoonnummer = _data["telefoonnummer"];
            this.mobielnummer = _data["mobielnummer"];
        }
    }

    static fromJS(data: any): Contactgegevens {
        data = typeof data === 'object' ? data : {};
        let result = new Contactgegevens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["telefoonnummer"] = this.telefoonnummer;
        data["mobielnummer"] = this.mobielnummer;
        return data;
    }
}

export interface IContactgegevens {
    email: string;
    telefoonnummer?: string | undefined;
    mobielnummer?: string | undefined;
}

export class CreateKlantcontactCommand implements ICreateKlantcontactCommand {
    persoonId?: number | undefined;
    regeling!: Regeling;
    taal!: Taal;
    persoonsgegevens!: Persoonsgegevens;
    contactgegevens!: Contactgegevens;
    formulier!: Formulier;
    bijlagen?: Bestand[] | undefined;

    constructor(data?: ICreateKlantcontactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.persoonsgegevens = data.persoonsgegevens && !(<any>data.persoonsgegevens).toJSON ? new Persoonsgegevens(data.persoonsgegevens) : <Persoonsgegevens>this.persoonsgegevens;
            this.contactgegevens = data.contactgegevens && !(<any>data.contactgegevens).toJSON ? new Contactgegevens(data.contactgegevens) : <Contactgegevens>this.contactgegevens;
            this.formulier = data.formulier && !(<any>data.formulier).toJSON ? new Formulier(data.formulier) : <Formulier>this.formulier;
            if (data.bijlagen) {
                this.bijlagen = [];
                for (let i = 0; i < data.bijlagen.length; i++) {
                    let item = data.bijlagen[i];
                    this.bijlagen[i] = item && !(<any>item).toJSON ? new Bestand(item) : <Bestand>item;
                }
            }
        }
        if (!data) {
            this.persoonsgegevens = new Persoonsgegevens();
            this.contactgegevens = new Contactgegevens();
            this.formulier = new Formulier();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.persoonId = _data["persoonId"];
            this.regeling = _data["regeling"];
            this.taal = _data["taal"];
            this.persoonsgegevens = _data["persoonsgegevens"] ? Persoonsgegevens.fromJS(_data["persoonsgegevens"]) : new Persoonsgegevens();
            this.contactgegevens = _data["contactgegevens"] ? Contactgegevens.fromJS(_data["contactgegevens"]) : new Contactgegevens();
            this.formulier = _data["formulier"] ? Formulier.fromJS(_data["formulier"]) : new Formulier();
            if (Array.isArray(_data["bijlagen"])) {
                this.bijlagen = [] as any;
                for (let item of _data["bijlagen"])
                    this.bijlagen!.push(Bestand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKlantcontactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKlantcontactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["persoonId"] = this.persoonId;
        data["regeling"] = this.regeling;
        data["taal"] = this.taal;
        data["persoonsgegevens"] = this.persoonsgegevens ? this.persoonsgegevens.toJSON() : <any>undefined;
        data["contactgegevens"] = this.contactgegevens ? this.contactgegevens.toJSON() : <any>undefined;
        data["formulier"] = this.formulier ? this.formulier.toJSON() : <any>undefined;
        if (Array.isArray(this.bijlagen)) {
            data["bijlagen"] = [];
            for (let item of this.bijlagen)
                data["bijlagen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKlantcontactCommand {
    persoonId?: number | undefined;
    regeling: Regeling;
    taal: Taal;
    persoonsgegevens: IPersoonsgegevens;
    contactgegevens: IContactgegevens;
    formulier: IFormulier;
    bijlagen?: IBestand[] | undefined;
}

export class CreateKlantcontactRouteringCommand implements ICreateKlantcontactRouteringCommand {
    formuliersleutel!: string;
    globaleRoute!: KlantcontactRoute;

    constructor(data?: ICreateKlantcontactRouteringCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.globaleRoute = data.globaleRoute && !(<any>data.globaleRoute).toJSON ? new KlantcontactRoute(data.globaleRoute) : <KlantcontactRoute>this.globaleRoute;
        }
        if (!data) {
            this.globaleRoute = new KlantcontactRoute();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formuliersleutel = _data["formuliersleutel"];
            this.globaleRoute = _data["globaleRoute"] ? KlantcontactRoute.fromJS(_data["globaleRoute"]) : new KlantcontactRoute();
        }
    }

    static fromJS(data: any): CreateKlantcontactRouteringCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKlantcontactRouteringCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formuliersleutel"] = this.formuliersleutel;
        data["globaleRoute"] = this.globaleRoute ? this.globaleRoute.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateKlantcontactRouteringCommand {
    formuliersleutel: string;
    globaleRoute: IKlantcontactRoute;
}

export class ErrorResponse implements IErrorResponse {
    message?: string | undefined;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorResponse {
    message?: string | undefined;
}

export class Formulier implements IFormulier {
    sleutel!: string;
    onderwerp!: string;
    behandelaarsOnderwerp?: string | undefined;
    secties!: FormulierSectie[];

    constructor(data?: IFormulier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.secties) {
                this.secties = [];
                for (let i = 0; i < data.secties.length; i++) {
                    let item = data.secties[i];
                    this.secties[i] = item && !(<any>item).toJSON ? new FormulierSectie(item) : <FormulierSectie>item;
                }
            }
        }
        if (!data) {
            this.secties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sleutel = _data["sleutel"];
            this.onderwerp = _data["onderwerp"];
            this.behandelaarsOnderwerp = _data["behandelaarsOnderwerp"];
            if (Array.isArray(_data["secties"])) {
                this.secties = [] as any;
                for (let item of _data["secties"])
                    this.secties!.push(FormulierSectie.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Formulier {
        data = typeof data === 'object' ? data : {};
        let result = new Formulier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sleutel"] = this.sleutel;
        data["onderwerp"] = this.onderwerp;
        data["behandelaarsOnderwerp"] = this.behandelaarsOnderwerp;
        if (Array.isArray(this.secties)) {
            data["secties"] = [];
            for (let item of this.secties)
                data["secties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormulier {
    sleutel: string;
    onderwerp: string;
    behandelaarsOnderwerp?: string | undefined;
    secties: IFormulierSectie[];
}

export class FormulierSamenvatting implements IFormulierSamenvatting {
    bestandsnaam!: string;
    base64Inhoud!: string;

    constructor(data?: IFormulierSamenvatting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bestandsnaam = _data["bestandsnaam"];
            this.base64Inhoud = _data["base64Inhoud"];
        }
    }

    static fromJS(data: any): FormulierSamenvatting {
        data = typeof data === 'object' ? data : {};
        let result = new FormulierSamenvatting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestandsnaam"] = this.bestandsnaam;
        data["base64Inhoud"] = this.base64Inhoud;
        return data;
    }
}

export interface IFormulierSamenvatting {
    bestandsnaam: string;
    base64Inhoud: string;
}

export class FormulierSectie implements IFormulierSectie {
    titel!: string;
    vragen!: FormulierVraag[];

    constructor(data?: IFormulierSectie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.vragen) {
                this.vragen = [];
                for (let i = 0; i < data.vragen.length; i++) {
                    let item = data.vragen[i];
                    this.vragen[i] = item && !(<any>item).toJSON ? new FormulierVraag(item) : <FormulierVraag>item;
                }
            }
        }
        if (!data) {
            this.vragen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titel = _data["titel"];
            if (Array.isArray(_data["vragen"])) {
                this.vragen = [] as any;
                for (let item of _data["vragen"])
                    this.vragen!.push(FormulierVraag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormulierSectie {
        data = typeof data === 'object' ? data : {};
        let result = new FormulierSectie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titel"] = this.titel;
        if (Array.isArray(this.vragen)) {
            data["vragen"] = [];
            for (let item of this.vragen)
                data["vragen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormulierSectie {
    titel: string;
    vragen: IFormulierVraag[];
}

export class FormulierVraag implements IFormulierVraag {
    vraag!: string;
    antwoord!: string;
    antwoorden?: string[] | undefined;

    constructor(data?: IFormulierVraag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vraag = _data["vraag"];
            this.antwoord = _data["antwoord"];
            if (Array.isArray(_data["antwoorden"])) {
                this.antwoorden = [] as any;
                for (let item of _data["antwoorden"])
                    this.antwoorden!.push(item);
            }
        }
    }

    static fromJS(data: any): FormulierVraag {
        data = typeof data === 'object' ? data : {};
        let result = new FormulierVraag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vraag"] = this.vraag;
        data["antwoord"] = this.antwoord;
        if (Array.isArray(this.antwoorden)) {
            data["antwoorden"] = [];
            for (let item of this.antwoorden)
                data["antwoorden"].push(item);
        }
        return data;
    }
}

export interface IFormulierVraag {
    vraag: string;
    antwoord: string;
    antwoorden?: string[] | undefined;
}

export class KlantcontactBevestiging implements IKlantcontactBevestiging {
    klantcontactnummer?: number;
    bericht?: string | undefined;
    formulierSamenvatting?: FormulierSamenvatting | undefined;

    constructor(data?: IKlantcontactBevestiging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.formulierSamenvatting = data.formulierSamenvatting && !(<any>data.formulierSamenvatting).toJSON ? new FormulierSamenvatting(data.formulierSamenvatting) : <FormulierSamenvatting>this.formulierSamenvatting;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klantcontactnummer = _data["klantcontactnummer"];
            this.bericht = _data["bericht"];
            this.formulierSamenvatting = _data["formulierSamenvatting"] ? FormulierSamenvatting.fromJS(_data["formulierSamenvatting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KlantcontactBevestiging {
        data = typeof data === 'object' ? data : {};
        let result = new KlantcontactBevestiging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klantcontactnummer"] = this.klantcontactnummer;
        data["bericht"] = this.bericht;
        data["formulierSamenvatting"] = this.formulierSamenvatting ? this.formulierSamenvatting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKlantcontactBevestiging {
    klantcontactnummer?: number;
    bericht?: string | undefined;
    formulierSamenvatting?: IFormulierSamenvatting | undefined;
}

export class KlantcontactRoute implements IKlantcontactRoute {
    gebruikersgroep!: number;
    afdeling!: number;
    onderwerp!: number;

    constructor(data?: IKlantcontactRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gebruikersgroep = _data["gebruikersgroep"];
            this.afdeling = _data["afdeling"];
            this.onderwerp = _data["onderwerp"];
        }
    }

    static fromJS(data: any): KlantcontactRoute {
        data = typeof data === 'object' ? data : {};
        let result = new KlantcontactRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gebruikersgroep"] = this.gebruikersgroep;
        data["afdeling"] = this.afdeling;
        data["onderwerp"] = this.onderwerp;
        return data;
    }
}

export interface IKlantcontactRoute {
    gebruikersgroep: number;
    afdeling: number;
    onderwerp: number;
}

export class KlantcontactRouteReadModel implements IKlantcontactRouteReadModel {
    gebruikersgroep?: number;
    afdeling?: number;
    onderwerp?: number;

    constructor(data?: IKlantcontactRouteReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gebruikersgroep = _data["gebruikersgroep"];
            this.afdeling = _data["afdeling"];
            this.onderwerp = _data["onderwerp"];
        }
    }

    static fromJS(data: any): KlantcontactRouteReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new KlantcontactRouteReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gebruikersgroep"] = this.gebruikersgroep;
        data["afdeling"] = this.afdeling;
        data["onderwerp"] = this.onderwerp;
        return data;
    }
}

export interface IKlantcontactRouteReadModel {
    gebruikersgroep?: number;
    afdeling?: number;
    onderwerp?: number;
}

export class KlantcontactRouteringOverrideReadModel implements IKlantcontactRouteringOverrideReadModel {
    regeling?: Regeling;
    route?: KlantcontactRouteReadModel | undefined;

    constructor(data?: IKlantcontactRouteringOverrideReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.route = data.route && !(<any>data.route).toJSON ? new KlantcontactRouteReadModel(data.route) : <KlantcontactRouteReadModel>this.route;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regeling = _data["regeling"];
            this.route = _data["route"] ? KlantcontactRouteReadModel.fromJS(_data["route"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KlantcontactRouteringOverrideReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new KlantcontactRouteringOverrideReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regeling"] = this.regeling;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKlantcontactRouteringOverrideReadModel {
    regeling?: Regeling;
    route?: IKlantcontactRouteReadModel | undefined;
}

export class KlantcontactRouteringReadModel implements IKlantcontactRouteringReadModel {
    formuliersleutel?: string | undefined;
    route?: KlantcontactRouteReadModel | undefined;
    overrides?: KlantcontactRouteringOverrideReadModel[] | undefined;

    constructor(data?: IKlantcontactRouteringReadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.route = data.route && !(<any>data.route).toJSON ? new KlantcontactRouteReadModel(data.route) : <KlantcontactRouteReadModel>this.route;
            if (data.overrides) {
                this.overrides = [];
                for (let i = 0; i < data.overrides.length; i++) {
                    let item = data.overrides[i];
                    this.overrides[i] = item && !(<any>item).toJSON ? new KlantcontactRouteringOverrideReadModel(item) : <KlantcontactRouteringOverrideReadModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formuliersleutel = _data["formuliersleutel"];
            this.route = _data["route"] ? KlantcontactRouteReadModel.fromJS(_data["route"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(KlantcontactRouteringOverrideReadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KlantcontactRouteringReadModel {
        data = typeof data === 'object' ? data : {};
        let result = new KlantcontactRouteringReadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formuliersleutel"] = this.formuliersleutel;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKlantcontactRouteringReadModel {
    formuliersleutel?: string | undefined;
    route?: IKlantcontactRouteReadModel | undefined;
    overrides?: IKlantcontactRouteringOverrideReadModel[] | undefined;
}

export class Persoonsgegevens implements IPersoonsgegevens {
    voornaam?: string | undefined;
    achternaam?: string | undefined;
    geslacht?: string | undefined;
    geboortedatum?: Date | undefined;
    burgerservicenummer?: string | undefined;
    klantId?: string | undefined;

    constructor(data?: IPersoonsgegevens) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voornaam = _data["voornaam"];
            this.achternaam = _data["achternaam"];
            this.geslacht = _data["geslacht"];
            this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>undefined;
            this.burgerservicenummer = _data["burgerservicenummer"];
            this.klantId = _data["klantId"];
        }
    }

    static fromJS(data: any): Persoonsgegevens {
        data = typeof data === 'object' ? data : {};
        let result = new Persoonsgegevens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voornaam"] = this.voornaam;
        data["achternaam"] = this.achternaam;
        data["geslacht"] = this.geslacht;
        data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>undefined;
        data["burgerservicenummer"] = this.burgerservicenummer;
        data["klantId"] = this.klantId;
        return data;
    }
}

export interface IPersoonsgegevens {
    voornaam?: string | undefined;
    achternaam?: string | undefined;
    geslacht?: string | undefined;
    geboortedatum?: Date | undefined;
    burgerservicenummer?: string | undefined;
    klantId?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum Regeling {
    BeschermdWonen = "BeschermdWonen",
    Buitenland = "Buitenland",
    CBHC = "CBHC",
    Gemoedsbezwaarden = "Gemoedsbezwaarden",
    MedicijnenMeeOpReis = "MedicijnenMeeOpReis",
    OnverzekerbareVreemdelingen = "OnverzekerbareVreemdelingen",
    Onverzekerden = "Onverzekerden",
    SOV = "SOV",
    BetalingsachterstandZorgpremie = "BetalingsachterstandZorgpremie",
    Wlz = "Wlz",
    WmoAT = "WmoAT",
    Onbekend = "Onbekend",
}

export enum Taal {
    Nederlands = "Nederlands",
    Engels = "Engels",
}

export class UpdateKlantcontactRouteringCommand implements IUpdateKlantcontactRouteringCommand {
    formuliersleutel!: string;
    globaleRoute!: KlantcontactRoute;

    constructor(data?: IUpdateKlantcontactRouteringCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.globaleRoute = data.globaleRoute && !(<any>data.globaleRoute).toJSON ? new KlantcontactRoute(data.globaleRoute) : <KlantcontactRoute>this.globaleRoute;
        }
        if (!data) {
            this.globaleRoute = new KlantcontactRoute();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formuliersleutel = _data["formuliersleutel"];
            this.globaleRoute = _data["globaleRoute"] ? KlantcontactRoute.fromJS(_data["globaleRoute"]) : new KlantcontactRoute();
        }
    }

    static fromJS(data: any): UpdateKlantcontactRouteringCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKlantcontactRouteringCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formuliersleutel"] = this.formuliersleutel;
        data["globaleRoute"] = this.globaleRoute ? this.globaleRoute.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateKlantcontactRouteringCommand {
    formuliersleutel: string;
    globaleRoute: IKlantcontactRoute;
}

export class UpdateKlantcontactRouteringOverrideCommand implements IUpdateKlantcontactRouteringOverrideCommand {
    formuliersleutel!: string;
    regeling!: Regeling;
    route!: KlantcontactRoute;

    constructor(data?: IUpdateKlantcontactRouteringOverrideCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.route = data.route && !(<any>data.route).toJSON ? new KlantcontactRoute(data.route) : <KlantcontactRoute>this.route;
        }
        if (!data) {
            this.route = new KlantcontactRoute();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formuliersleutel = _data["formuliersleutel"];
            this.regeling = _data["regeling"];
            this.route = _data["route"] ? KlantcontactRoute.fromJS(_data["route"]) : new KlantcontactRoute();
        }
    }

    static fromJS(data: any): UpdateKlantcontactRouteringOverrideCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKlantcontactRouteringOverrideCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formuliersleutel"] = this.formuliersleutel;
        data["regeling"] = this.regeling;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateKlantcontactRouteringOverrideCommand {
    formuliersleutel: string;
    regeling: Regeling;
    route: IKlantcontactRoute;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
